
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import { handleKeyDown } from '../../../util/utils'

class FaqSectionMasterModal extends PureComponent {
  submitFaq (values) {
    let organizedUnitId = null
    const body = []

    Object.keys(values.languageList).map(item => {
      let languageId = values.languageList[item].languageId
      body.push(values[`lang${languageId}`])
    })
    organizedUnitId = values.organizedUnitId

    this.props.actions.saveFaqSection(this.props.faqSectionId, organizedUnitId, body)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.showModal !== this.props.showModal && nextProps.showModal === true) {
      this.props.initialize({ ...nextProps })
    }
    if (this.props.translations !== nextProps.translations) {
      nextProps.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const nextTranslation = nextProps.translations.find((faqSection) => faqSection.languageId === language.languageId)
        if (nextTranslation && nextTranslation !== undefined) {
          this.props.change(`lang${language.languageId}.name`, nextTranslation.name)
          this.props.change(`lang${language.languageId}.description`, nextTranslation.description)
        }
      })

      if (this.props.organizedUnitId !== nextProps.organizedUnitId) {
        this.props.change('organizedUnitId', nextProps.organizedUnitId ? nextProps.organizedUnitId.toString() : '')
      }
    }
  }

  render () {
    const { t, showModal, handleSubmit, languageList = [], combos: { UOTreeCombo }, actions: { closeFaqSectionModal } } = this.props
    return (
      <Modal id="FaqSectionMasterModal" show={showModal} onHide={closeFaqSectionModal} className="_nf languages-modal">
        <Modal.Header closeButton>
          <Modal.Title>{t('MASTERS.FAQSECTION.TITLE')}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitFaq.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t('MASTERS.FAQSECTION.ORGANIZED_UNIT')}
                placeholder={t('MASTERS.FAQSECTION.ORGANIZED_UNIT')}

                multi={false}
                allowClear={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                colSm={0}
                options={UOTreeCombo}
                showSearch={false}
              />
            </div>
            <SimpleTablePage
              customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.FAQSECTION.TITLE_FIELD')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.FAQSECTION.DESCRIPTION_FIELD')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`] !== undefined) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    }
  })
  return errors
}

export default reduxForm({
  form: 'editFaqSection',
  validate
})(FaqSectionMasterModal)
